/**
 * Figma dev export (4830:6583 / bg/02) — linear fill on the layer that uses
 * `rotate(-90deg)` + `transform-origin: top left` so the gradient’s 180° axis
 * runs along the card’s long edge after rotation.
 */
export const LAUNCH_SUMMARY_PANEL_GRADIENT =
  'linear-gradient(180deg, #041E42 3%, #172A48 98%, #172946 100%)'
